

















import Vue from "vue";

import { SearchAPIModels } from "search-api-client";

export default Vue.extend({
  name: "DateFilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: "Publish date",
    },
    options: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => [],
    },
    active: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => [],
    },
  },
  data() {
    return { selectedOption: 0 as number };
  },
  methods: {
    isChecked(value: Date): boolean {
      return (
        this.$props.active
          .map(function(
            e: SearchAPIModels.GenericSearchResponseFacetsCreatedItem
          ) {
            return e.value;
          })
          .indexOf(value) > -1
      );
    },
    emitChange(
      value: SearchAPIModels.GenericSearchResponseFacetsCreatedItem
    ): void {
      this.$emit("inputChange", value);
    },
  },
});
